import React from "react";
import TugPdfReport from "../../common/pdf/TugPdfReport";
const FrontTugPdfReport = () => <TugPdfReport reportType="front" />;
export default FrontTugPdfReport;
